import React from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions'; // Asegúrate de que la ruta sea la correcta
import DesktopFilterForm from './DesktopFilterForm';
import MobileFilterForm from './MobileFilterForm';
import { theme } from '../../theme';

const FilterForm = (props) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= parseInt(theme.breakpoints.md);

  return isMobile ? <MobileFilterForm {...props} /> : <DesktopFilterForm {...props} />;
};

export default FilterForm;
